import { ShieldAlert, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Blocked() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-bg-light px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-text-muted/20">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-secondary/10 rounded-full mb-6">
          <ShieldAlert className="w-10 h-10 text-secondary-dark" />
        </div>
        
        <h1 className="text-2xl font-bold text-text-main mb-4">
          Acesso Suspenso
        </h1>
        
        <p className="text-text-main/70 mb-8">
          Identificamos uma pendência financeira em sua assinatura. 
          Conforme nossos termos, o acesso é bloqueado após 30 dias de inadimplência.
        </p>

        <div className="bg-bg-light rounded-xl p-4 mb-8 text-left space-y-3">
          <p className="text-sm font-semibold text-text-main mb-2">Para regularizar seu acesso:</p>
          <div className="flex items-center text-sm text-text-main/70">
            <Phone className="w-4 h-4 mr-2 text-primary" />
            <span>(61) 3041-3218</span>
          </div>
          <div className="flex items-center text-sm text-text-main/70">
            <Mail className="w-4 h-4 mr-2 text-primary" />
            <span>telemedicina@novitahomecare.com.br</span>
          </div>
        </div>

        <div className="space-y-4">
          <button 
            onClick={() => window.location.reload()}
            className="w-full bg-primary hover:bg-primary-dark text-white font-bold py-3 rounded-lg transition-all shadow-md shadow-primary/20"
          >
            Já realizei o pagamento
          </button>
          
          <Link 
            to="/"
            className="block text-sm font-medium text-text-muted hover:text-primary transition-colors"
          >
            Voltar para a página inicial
          </Link>
        </div>
      </div>
    </div>
  );
}
